(function(){'use strict';
/* iOS: stop the page behind the options sheet from scrolling. No position:fixed on <body> (that moved the page under the sheet and
   made the theme re-run its scroll logic, which closed and reopened the sheet). Instead block only the touch moves that would leak out. */
var sx=0,sy=0;
function openDlg(){return document.querySelector('dialog.bezelor-variant-panel[open]');}
document.addEventListener('touchstart',function(e){if(!openDlg())return;var t=e.touches[0];sx=t.clientX;sy=t.clientY;},{passive:true});
document.addEventListener('touchmove',function(e){
  var d=openDlg();if(!d||e.touches.length>1)return;
  var t=e.touches[0],dx=t.clientX-sx,dy=t.clientY-sy;
  if(Math.abs(dx)>Math.abs(dy))return; /* sideways swipes (variant row) stay free */
  var sc=e.target.closest&&e.target.closest('.bezelor-panel-body');
  if(!sc||!d.contains(sc)){if(e.cancelable)e.preventDefault();return;}
  var atTop=sc.scrollTop<=0,atEnd=sc.scrollTop+sc.clientHeight>=sc.scrollHeight-1;
  if(((atTop&&dy>0)||(atEnd&&dy<0))&&e.cancelable)e.preventDefault();
},{passive:false});

/* Checkout hand-off screen: shown the instant a shopper heads to checkout, so Shopify's checkout load time never looks like a frozen page. */
var CSS='.bz-co{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;background:rgba(14,13,11,.95);opacity:0;visibility:hidden;transition:opacity .15s ease,visibility 0s linear .15s}'+
'.bz-co.is-on{opacity:1;visibility:visible;transition:opacity .15s ease}'+
'.bz-co__card{max-width:300px;padding:24px;text-align:center;color:#f4efe4}'+
'.bz-co__ring{position:relative;display:grid;place-items:center;width:64px;height:64px;margin:0 auto 18px;border-radius:50%}'+
'.bz-co__ring:before{content:"";position:absolute;inset:0;border-radius:50%;border:2px solid rgba(212,180,107,.2);border-top-color:#d4b46b;animation:bzCoSpin .8s linear infinite}'+
'.bz-co__ring svg{width:24px;height:24px;fill:none;stroke:#d4b46b;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}'+
'.bz-co__t{margin:0 0 6px;font:600 16px/1.3 var(--font-body-family),sans-serif;letter-spacing:.02em;color:#f4efe4}'+
'.bz-co__s{margin:0 0 18px;font:400 12.5px/1.4 var(--font-body-family),sans-serif;color:rgba(244,239,228,.6)}'+
'.bz-co__bar{width:200px;height:3px;margin:0 auto;overflow:hidden;border-radius:3px;background:rgba(212,180,107,.18)}'+
'.bz-co__bar i{display:block;width:0;height:100%;border-radius:3px;background:linear-gradient(90deg,#f3dc95,#c99a3e)}'+
'.bz-co.is-on .bz-co__bar i{animation:bzCoBar 7s cubic-bezier(.1,.7,.2,1) forwards}'+
'@keyframes bzCoSpin{to{transform:rotate(360deg)}}@keyframes bzCoBar{0%{width:0}15%{width:45%}55%{width:80%}100%{width:95%}}'+
'@media (prefers-reduced-motion:reduce){.bz-co__ring:before{animation-duration:2.4s}.bz-co.is-on .bz-co__bar i{animation:none;width:70%}}';
var ov,t1,t2;
function overlay(on){
  clearTimeout(t1);clearTimeout(t2);
  if(!on){if(ov)ov.classList.remove('is-on');return;}
  if(!ov){
    var st=document.createElement('style');st.textContent=CSS;document.head.appendChild(st);
    ov=document.createElement('div');ov.className='bz-co';ov.setAttribute('role','status');ov.setAttribute('aria-live','polite');
    ov.innerHTML='<div class="bz-co__card"><div class="bz-co__ring"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7.5 11V8a4.5 4.5 0 0 1 9 0v3M6 11h12v9H6z"/></svg></div><p class="bz-co__t"></p><p class="bz-co__s">Encrypted, secure payment</p><div class="bz-co__bar"><i></i></div></div>';
    document.body.appendChild(ov);
  }
  var t=ov.querySelector('.bz-co__t');t.textContent='Opening secure checkout';
  ov.classList.remove('is-on');void ov.offsetWidth;ov.classList.add('is-on');
  t1=setTimeout(function(){t.textContent='Almost there…';},3000);
  t2=setTimeout(function(){overlay(false);},25000); /* navigation failed or was cancelled: give the page back */
}
/* Back button from checkout: the page comes back from cache, so clear the hand-off state */
window.addEventListener('pageshow',function(){overlay(false);document.querySelectorAll('.bz-buynow').forEach(function(b){b.disabled=false;});});
/* Every other way into checkout (cart page button, Shopify's own Buy it now, checkout links) gets the same screen */
document.addEventListener('submit',function(e){var s=e.submitter,f=e.target;var co=(s&&s.name==='checkout')||/\/checkout/.test(f.getAttribute&&f.getAttribute('action')||'');if(co)setTimeout(function(){if(!e.defaultPrevented)overlay(true);},0);});
document.addEventListener('click',function(e){var el=e.target.closest&&e.target.closest('a[href*="/checkout"],.shopify-payment-button__button');if(el)setTimeout(function(){if(!e.defaultPrevented)overlay(true);},0);});

/* Buy now fallback: if Shopify's dynamic checkout button is not drawn, show a Buy now button styled like Add to cart.
   One navigation to the cart permalink (adds the item and lands on checkout), no request first. */
function ensureBuy(d){
  var box=d.querySelector('.bezelor-panel-actions .product-form__buttons');if(!box)return;
  var add=box.querySelector('.product-form__submit:not(.bz-buynow)');if(!add)return;
  var fb=box.querySelector('.bz-buynow');var buy=d.getAttribute('data-mode')==='buy';
  var pb=box.querySelector('.shopify-payment-button__button:not(.shopify-payment-button__button--hidden)');
  var seen=!!(pb&&pb.offsetHeight>0);
  if(!buy||seen){if(fb)fb.style.setProperty('display','none','important');return;}
  if(!fb){
    fb=add.cloneNode(true);fb.removeAttribute('id');fb.removeAttribute('name');fb.setAttribute('type','button');fb.classList.add('bz-buynow');fb.innerHTML='<span>Buy now</span>';
    fb.addEventListener('click',function(){
      var form=add.form||add.closest('form');if(!form||fb.disabled)return;
      var vid=form.querySelector('[name=id]'),q=form.elements.quantity,qty=Math.max(1,parseInt(q&&q.value,10)||1);
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      fb.disabled=true;overlay(true);try{d.close();}catch(e){}
      if(vid&&vid.value){window.location.href=root+'cart/'+vid.value+':'+qty;return;}
      fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('add failed');window.location.href=root+'checkout';})
        .catch(function(){fb.disabled=false;overlay(false);});
    });
    add.after(fb);
  }
  fb.disabled=!!add.disabled;fb.style.setProperty('display','flex','important');
}
function check(d){ensureBuy(d);setTimeout(function(){ensureBuy(d);},500);setTimeout(function(){ensureBuy(d);},1800);}
function sync(){var open=openDlg();if(open)check(open);}
function watchDialogs(){document.querySelectorAll('dialog.bezelor-variant-panel').forEach(function(d){
  if(d.__bzLock)return;d.__bzLock=true;
  new MutationObserver(sync).observe(d,{attributes:true,attributeFilter:['open','data-mode']});
  d.addEventListener('close',sync);d.addEventListener('cancel',function(){setTimeout(sync,0);});
});}
watchDialogs();new MutationObserver(watchDialogs).observe(document.documentElement,{childList:true,subtree:true});

/* Remove the Global-e merchant-of-record sentence wherever the app injects it on our pages. */
var RE=/by placing your order you agree to purchase from global-?e/i,queued=false;
function sweep(){queued=false;if(!document.body)return;var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),n,hit=[];
  while((n=w.nextNode()))if(RE.test(n.nodeValue))hit.push(n);
  hit.forEach(function(t){var el=t.parentElement;if(!el)return;var base=(el.textContent||'').length;
    while(el.parentElement&&el.parentElement!==document.body&&(el.parentElement.textContent||'').length<=base+20)el=el.parentElement;
    if(el!==document.body)el.style.setProperty('display','none','important');});}
function queue(){if(!queued){queued=true;setTimeout(sweep,150);}}
function start(){sweep();new MutationObserver(queue).observe(document.body,{childList:true,subtree:true,characterData:true});}
if(document.body)start();else document.addEventListener('DOMContentLoaded',start);
})();

/* Options sheet (phones/tablets): every product gets the same photo card with the colour pill, the quantity stepper sits on the photo
   and the "Color: ..." row is gone (the pill already names the colour). Super Deal card: the long saving note loses its repeat of "deal applied in cart"
   (the gold line above the button says it). */
(function(){
  var mq=window.matchMedia('(max-width:979px)'),busy=false;
  function fix(d){
    if(!d||!d.open||!mq.matches)return;
    var tiles=d.querySelectorAll('variant-selects .bezelor-image-variants label').length;
    if(tiles>0){
      if(!d.classList.contains('bz-sheet-hero'))d.classList.add('bz-sheet-hero');
      var c=tiles>4;if(d.classList.contains('is-hero-compact')!==c)d.classList.toggle('is-hero-compact',c);
      var q=d.querySelector('.product-form__quantity'),b=d.querySelector('.bezelor-panel-body');
      if(q&&b&&q.parentElement!==b)b.appendChild(q);
    }
    var s=d.querySelector('.bzfx-panel__save');
    if(s&&s.textContent.indexOf(' · deal applied in cart')>-1)s.textContent=s.textContent.replace(' · deal applied in cart','');
    var p=d.querySelector('.bezelor-panel-price.bzfx-panel'),dl=p&&p.querySelector('.bzfx-panel__deal');
    if(dl&&!p.querySelector('.bzfx-row')){
      var row=document.createElement('div');row.className='bzfx-row';dl.parentNode.insertBefore(row,dl);
      row.appendChild(dl);var was=p.querySelector('.bezelor-panel-original-price');if(was)row.appendChild(was);if(s)row.appendChild(s);
    }
  }
  function run(){if(busy)return;busy=true;try{fix(document.querySelector('dialog.bezelor-variant-panel[open]'));}finally{busy=false;}}
  function start(){new MutationObserver(run).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open']});}
  if(document.body)start();else document.addEventListener('DOMContentLoaded',start);
})();
